import { BigSymbolFreegamesCommonConfiguration } from "../../../api";
import { BigSymbolFreeGameBonus_1Screen } from "./BigSymbolFreeGameBonus_1Screen";
import { BigSymbolFreegamesBonus } from "./BigSymbolFreegames";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import { BigSymbolFreegamesBonusFactory } from "./BigSymbolFreegamesFactory";
import { BigSymbolFreegamesBonusParams } from "./BigSymbolFreegamesParams";

export class BigSymbolFreegamesBonusFactory_1Screen extends BigSymbolFreegamesBonusFactory
{
	public CreateBigSymbolFreegamesBonus_1Screen(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegamesBonus
	{
		return new BigSymbolFreeGameBonus_1Screen(gameName, params, config);
	}
}